export default __webpack_public_path__ + "static/media/draftstars-myteams.08ad5262.svg";